import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Actions as PAYMENT_INTEGRATION_ACTIONS } from "./store/paymentIntegrationActions";
import { format, addYears, set, parse } from "date-fns";
import DatePicker from "react-datepicker";
import Spinner from "../../common/Spinner";
import ProgressBar from "../../common/ProgressBar";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { camelCase } from "lodash";

const PaymentIntegrationPayments = ({
	integration, // name of integration
	integrationName,
	period,
	employeesToSync,
	getEmployeesToSync,
	stage,
	setPaymentStage,
	syncEmployees,
	syncingStatus,
	employeesToSyncList,
	paymentIntegrationLogo,
}) => {
	const today = set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
	const [transferDate, setTransferDate] = useState(today);
	const [forLater, setForLater] = useState();

	useEffect(() => {
		// TODO update to enable only if Employee sync is required
		if (false) {
			getEmployeesToSync(integration, period.id);
		}
	}, []);

	useEffect(() => {
		if (period) {
			const payDate = parse(period?.payDay, "yyyy-MM-dd", new Date());
			setTransferDate(payDate > today ? payDate : today);
		}
		setPaymentStage("Review");
	}, [period?.id]);

	const setReview = (forLater) => {
		setForLater(forLater);
		setPaymentStage();
	};

	switch (stage) {
		case "Review":
			return (
				<div
					className="block-content"
					style={{ padding: 20 }}
				>
					{!forLater && (
						<p style={{ textAlign: "center" }}>
							You're about to send payments for this payroll to {integrationName}
						</p>
					)}

					{forLater && (
						<div style={{ padding: 20, width: "50%" }}>
							<div className="form-material">
								<label>Transfer Date</label>
								<DatePicker
									selected={transferDate}
									onChange={(date) => setTransferDate(date)}
									minDate={today}
									maxDate={addYears(new Date(), 100)}
									dateFormat="dd/MM/yyyy"
								/>
							</div>
						</div>
					)}

					<div
						style={{
							display: "flex",
							justifyContent: "center",
							paddingTop: 20,
							paddingBottom: 20,
						}}
					>
						{!employeesToSyncList ? (
							<Spinner
								style={{ height: "2rem", width: "2rem", margin: 0 }}
								className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right"
							/>
						) : (
							<div>
								<button
									className="btn btn-default"
									onClick={() =>
										syncEmployees(
											period.id,
											forLater ? transferDate.toISOString() : new Date().toISOString(),
										)
									}
								>
									<img
										src={paymentIntegrationLogo}
										style={{ height: "1.5em", float: "left", marginRight: 5 }}
									/>
									<div style={{ float: "left" }}>{employeesToSync && "Sync & "}Pay Employees</div>
								</button>
							</div>
						)}
					</div>
					{employeesToSync && (
						<p style={{ textAlign: "center" }}>
							<a>
								<strong>{employeesToSync}</strong>
							</a>{" "}
							employees require syncing
						</p>
					)}
				</div>
			);
		case "Syncing":
			return (
				<div
					className="block-content"
					style={{ padding: 40 }}
				>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							paddingTop: 20,
							paddingBottom: 20,
						}}
					>
						<div style={{ float: "left" }}>Syncing Employees</div>
						<div style={{ marginLeft: 5, float: "left" }}>
							<Spinner
								style={{ height: "2rem", width: "2rem", margin: 0 }}
								className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right"
							/>
						</div>
					</div>

					<ProgressBar percentage={syncingStatus} />
				</div>
			);
		case "Sending":
			return (
				<div
					className="block-content"
					style={{ padding: 40 }}
				>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							paddingTop: 20,
							paddingBottom: 20,
						}}
					>
						<div style={{ float: "left" }}>Sending Payroll Information to {integrationName}</div>
						<div style={{ marginLeft: 5, float: "left" }}>
							<Spinner
								style={{ height: "2rem", width: "2rem", margin: 0 }}
								className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right"
							/>
						</div>
					</div>
				</div>
			);
		case "Done":
			return (
				<div
					className="block-content"
					style={{ padding: 20 }}
				>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							paddingTop: 20,
							paddingBottom: 20,
						}}
					>
						<img
							src={paymentIntegrationLogo}
							style={{ height: "4rem" }}
						/>
					</div>
					<h3 style={{ textAlign: "center" }}>Success!</h3>
					<p style={{ textAlign: "center", margin: 0 }}>Your payments were sent successfully</p>
					<p style={{ textAlign: "center" }}>Kindly confirm on {integrationName} to finalise your payments</p>
				</div>
			);
		case "Error":
			return (
				<div
					className="block-content flex justify-center flex-col items-center"
					style={{ padding: 20 }}
				>
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							paddingTop: 20,
						}}
					>
						<ExclamationTriangleIcon style={{ height: "4rem" }} />
					</div>
					<h3 style={{ textAlign: "center" }}>An error has occurred</h3>
					<p style={{ textAlign: "center" }}>Your payments have not been processed</p>
					<button
						className="btn-default btn"
						onClick={() => setPaymentStage(true)}
					>
						Retry
					</button>
				</div>
			);
	}

	return (
		<div
			className="block-content"
			style={{ padding: 20 }}
		>
			<p style={{ textAlign: "center" }}>
				You're about to send payments for this payroll to {integrationName}. You can either send them now or
				schedule for a later date.
			</p>

			<div
				style={{
					display: "flex",
					flexDirection: "row",
					paddingTop: 20,
					paddingBottom: 20,
				}}
			>
				<div
					style={{
						width: "40%",
						textAlign: "center",
					}}
				>
					<button
						className="btn btn-success"
						onClick={() => setReview(false)}
					>
						Pay Now
					</button>
				</div>
				<div
					style={{
						flexGrow: 2,
						alignSelf: "center",
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
						}}
					>
						<hr
							style={{
								flexGrow: 1,
								margin: 5,
							}}
						/>
						<span>or</span>
						<hr
							style={{
								flexGrow: 1,
								margin: 5,
							}}
						/>
					</div>
				</div>

				<div
					style={{
						width: "40%",
						textAlign: "center",
					}}
				>
					<button
						className="btn btn-success"
						onClick={() => setReview(true)}
					>
						Schedule For Later
					</button>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { integration } = ownProps;
	const integrationProperties = state?.integration?.payment?.[camelCase(integration)] || {};
	return {
		employeesToSync: integrationProperties?.unsyncedEmployees?.length || null,
		employeesToSyncList: integrationProperties?.unsyncedEmployees || true, // defaults to true as we are not using this
		syncingStatus: integrationProperties?.syncingStatus,
		stage: integrationProperties?.stage,
		paymentIntegrationLogo: state.integrationDetails?.payment?.[camelCase(integration)]?.logo,
		integrationName: integrationProperties?.name,
		period: state?.company?.bankTransferModal?.period,
		isModalOpen: state?.company?.bankTransferModal?.isOpen,
	};
};

const mapDispatchToProps = (dispatch, { integration }) => ({
	syncEmployees: (payPeriodId, transferDate) =>
		dispatch(PAYMENT_INTEGRATION_ACTIONS.syncEmployees(integration, payPeriodId, transferDate)),
	setPaymentStage: (clear) =>
		dispatch(PAYMENT_INTEGRATION_ACTIONS.setPaymentStage(integration, clear ? undefined : "Review")),
	getEmployeesToSync: (payPeriodId) =>
		dispatch(PAYMENT_INTEGRATION_ACTIONS.getEmployeesToSync(integration, payPeriodId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentIntegrationPayments);
